import {
  Grid,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Button,
  FormGroup,
  FormControlLabel,
  Checkbox,
  TextField,
} from '@mui/material';
import { useState } from 'react';
import { useIntl } from 'react-intl';

interface SearchFormProps {
  handleSearch: (product: string, archive: boolean, recordLocator: string) => void;
}

const SearchForm: React.FC<SearchFormProps> = ({ handleSearch }) => {
  const intl = useIntl();
  const [product, setProduct] = useState('');
  const [archive, setArchive] = useState(false);
  const [recordLocator, setRecordLocator] = useState('');
  return (
    <Grid container direction="row" justifyContent="center" alignItems="center" gap="20px">
      <Grid item xs={2}>
        <FormControl variant="filled" fullWidth>
          <InputLabel id="product-label">{intl.formatMessage({ id: 'global.product' })}</InputLabel>
          <Select name="product" labelId="product-label" value={product} onChange={e => setProduct(e.target.value)}>
            <MenuItem value="all">All</MenuItem>
            <MenuItem value="atcomres">Atcomres</MenuItem>
            <MenuItem value="atcomnr">Atcomnr</MenuItem>
          </Select>
        </FormControl>
      </Grid>
      <Grid item xs={2}>
        <TextField
          type="text"
          name="recordLocator"
          variant="filled"
          label={intl.formatMessage({ id: 'global.recordLocator' })}
          fullWidth
          inputProps={{ maxLength: 6, style: { textTransform: 'uppercase' } }}
          value={recordLocator}
          onChange={e => setRecordLocator(e.target.value.toUpperCase())}
        />
      </Grid>
      <Grid item xs={2}>
        <FormGroup row>
          <FormControlLabel
            control={<Checkbox checked={archive} onChange={e => setArchive(e.target.checked)} />}
            label={intl.formatMessage({ id: 'global.displayArchive' })}
            labelPlacement="end"
            sx={{ '& .MuiFormControlLabel-label': { lineHeight: 'normal' } }}
          />
        </FormGroup>
      </Grid>
      <Grid item xs={2}>
        <Button
          variant="contained"
          color="primary"
          size="large"
          type="submit"
          id="submit"
          onClick={() => handleSearch(product === 'all' ? '' : product, archive, recordLocator)}
          style={{ marginRight: '20px', marginLeft: '20px', height: '56px' }}
        >
          {intl.formatMessage({ id: 'global.search' })}
        </Button>
      </Grid>
    </Grid>
  );
};

export default SearchForm;
